import { IMAGE_NOPHOTO_URL } from '../config/config'
import {getLicienseStatuses} from "../services/licienseStatusService";

export const CarUtil = {
  convertDepositRegistration(deposit_registration_id){
    switch (deposit_registration_id) {
      case 1:
        return 'มัดจำเล่ม';
      case 2:
        return 'ไม่มัดจำ';
      default:
        return '-'
    }
  },
 convertLicenseIdToName(liciense_status_id) {
    // let liciense_status = await getLicienseStatuses()
   // console.log('liciense_status==', liciense_status)
    switch (liciense_status_id) {
      case 0:
        return '--ไม่ระบุ--';
      case 1:
        return 'มีเล่มทะเบียน';
      case 2:
        return 'ยังไม่ปิดบัญชี';
      case 3:
        return 'รอเล่มปิดบัญชี';
      case 4:
        return 'มีเล่มอยู่เต็นท์';
      case 5:
        return 'ไม่มีเล่ม';
      case 6: return 'เล่มพร้อม';
      case 7: return 'รอเล่ม';
      case 8: return 'รอแจ้งย้าย';
      case 9: return 'รอรับเข้า';
      case 10: return 'ยังไม่ปิดบัญชี(ผ่อนต่อ)';
      case 11: return 'เล่มระงับ';
      default:
        return '-'
    }
  },
  convertVatPersonToName(person_vat_id) {
    switch (person_vat_id) {
      case 0:
        return '-';
      case 1:
        return 'บุคคล/รถบ้าน';
      case 2:
        return 'รถ VAT';
      case 3:
        return 'รถฝากขาย';
    }
  },
  getCarBlamesInit(page) {
    let car_blames = []
    let src = page === 'car_new' ? 'img/add_image.png' : IMAGE_NOPHOTO_URL
    let car_upload_id = '0'
    for (let i=1; i <= 16;i++) {
      let no = String(i);
      let name = i === 16 ? 'assessment_sheet' : 'car_blame'+i;
      // assessment_sheet
      let label = i === 16 ? 'ใบประเมินสภาพ(ภาพ, pdf)' : 'ตำหนิรถ '+i;
      let car_blame = {
        no: no,
        name: name,
        label: label,
        src: src,
        car_upload_id: car_upload_id,
        url: ''
      }
      car_blames.push(car_blame)
    }
    return car_blames
  },
  findFirstNumber(text) {
    for(let i=0;i<text.length;i++){
      if(isNaN(text[i])===false){
        return i
      }
    }
    return 0
  },
  convertDocStatusName(doc_status){
    // COMMENT 'N = New (Add New DOC)\nA = Approve\nR = Reject',
    switch (doc_status) {
      case 'N':
        return 'เอกสารใหม่';
      case 'A':
        return 'อนุมัติ';
      case 'R':
        return 'ยกเลิก';
      default:
        return ''
    }
  }
}
